export default __webpack_public_path__ + "static/media/footer30.7b91898d.jpg";